[
  {
    "title": "Menu",
    "items": [
      {
        "title": "Dashboard",
        "routerLink": "/overview",
        "icon": "folder"
      },
      {
        "title": "Assets",
        "routerLink": "assets",
        "icon": "asset",
        "acl": {
          "role": "can_read_assets",
          "resource": "assets"
        }
      }
    ]
  },
  {
    "title": "Settings",
    "items": [
      {
        "title": "Settings",
        "routerLink": "settings",
        "icon": "settings",
        "acl": {
          "role": "can_view_settings",
          "resource": "settings-service"
        }
      },
      {
        "title": "Team",
        "routerLink": "org/team-members",
        "icon": "team",
        "acl": {
          "role": "can_view_team_members",
          "resource": "team-service"
        },
        "dataTestId": "team-members-menu-item"
      }
    ]
  },
  {
    "title": "Admin",
    "items": [
      {
        "title": "Operations",
        "routerLink": "assets/manage",
        "icon": "asset",
        "acl": {
          "role": "can_manage_global_assets",
          "resource": "assets"
        },
        "dataTestId": "manage-assets-menu-item"
      },
      {
        "title": "Inventory",
        "routerLink": "org/manage",
        "icon": "team",
        "acl": {
          "role": "can_manage_global_teams",
          "resource": "team-service"
        },
        "dataTestId": "manage-inventory-menu-item"
      },
      {
        "title": "Finance",
        "routerLink": "org/manage",
        "icon": "team",
        "acl": {
          "role": "can_manage_global_teams",
          "resource": "team-service"
        },
        "dataTestId": "manage-finance-menu-item"
      }
    ]
  }
]
